import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { TotalProveiderMonth } from "../NetworkPortal/PayOut/helper";
import { getNetworkMenuId } from "../../Utils/types";
import CustomPagination from "../../common/CustomPagination";
import { payOutHeaderValue } from "../NetworkPortal/PayOut/AdditionalApptHeader";
import { GetTotalAppointmentAction } from "../../redux/actions/InsBillAction";
import { EnableForInsurer } from "./EnableForInsurer";

export const InsTotalAppointments = ({
  searchFilter,
  providerDetail,
  setProviderDetail,
  setSearchFilter,
  header,
  setHeader,
  setSelectAllFlag,
  setSelectAll,
  showData,
  setShowData,
  insBillReducer,
  setOpenModel,
  openModel,
}) => {
  const dispatch = useDispatch();
  const globalReducer = useSelector((state) => state?.globalReducer);
  const [enable, setEnabel] = useState(false);
  const [tableIndex, setTableIndex] = useState(null);

  useEffect(() => {
    dispatch(
      GetTotalAppointmentAction({
        ...searchFilter,
        page: 1,
        rows: 10,
        IsPayoutStatus: true,
      })
    );
  }, []);

  return (
    <>
      <div className="table-responsive __custom__properties">
        <table className="table">
          <thead>
            <tr className="avanishtbl">
              <th>
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={
                    insBillReducer?.getInsAppointmentDetail?.length ===
                    providerDetail?.length
                  }
                  onClick={(e) => {
                    if (e.target.checked) {
                      setProviderDetail(
                        insBillReducer?.getInsAppointmentDetail
                      );
                      setSelectAllFlag(true);
                    } else {
                      setSelectAll(false);
                      setProviderDetail([]);
                      setSelectAllFlag(false);
                    }
                  }}
                  readOnly
                />
              </th>

              <th style={{ textAlign: "center" }}>Insurer Name</th>
              <th style={{ textAlign: "center" }}>Policy Ref No</th>
              <th style={{ textAlign: "center" }}>Case No</th>
              <th>Insurer Amount</th>
              <th>GST</th>
              {header.map((ele) => {
                return (
                  <th
                    className={`${
                      ele === "Test Details" ||
                      ele === "Additional Test" ||
                      ele === "Tests" ||
                      ele === "Package"
                        ? "financeAdditionalTest"
                        : "addHeader"
                    }`}
                  >
                    {ele}
                  </th>
                );
              })}
              <th style={{ textAlign: "center" }}>Status</th>
              <th style={{ textAlign: "center" }}>QC Approval</th>

              <th className="addHeader">Action</th>
            </tr>
          </thead>
          {insBillReducer?.getInsAppointmentDetail?.length > 0 && (
            <tbody>
              {insBillReducer?.getInsAppointmentDetail?.map(
                (ele, itemIndex) => {
                  return (
                    <tr key={itemIndex}>
                      <td>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={providerDetail?.some((item) => ele === item)}
                          onClick={(e) => {
                            if (e.target.checked) {
                              setProviderDetail([...providerDetail, ele]);
                            } else {
                              setSelectAllFlag(false);
                              setSelectAll(false);
                              setProviderDetail(
                                providerDetail?.filter((item) => ele !== item)
                              );
                            }
                          }}
                          readOnly
                        />
                      </td>
                      <td style={{ minWidth: "200px" }}>{ele?.clientName}</td>
                      <td style={{ textAlign: "center" }}>
                        {ele?.policyRefNo}
                      </td>
                      <td style={{ textAlign: "center", minWidth: "200px" }}>
                        {ele?.caseNo}
                      </td>
                      {/* <td style={{ minWidth: "200px" }}>{ele?.proposerName}</td> */}
                      <td style={{ textAlign: "center", minWidth: "130px" }}>
                        {ele?.insurerSum?.toLocaleString("en-IN")}
                      </td>
                      <td>{ele?.gst?.toLocaleString("en-IN")}</td>

                      {header.map((col, index) => {
                        return (
                          <td
                            key={index}
                            className={`${
                              col === "Test Details" || col === "Package"
                                ? "payOutAdditionalTest"
                                : "addHeader"
                            }`}
                          >
                            {col === "Test Details" && ele.tests !== null ? (
                              <>
                                {showData === true && tableIndex === itemIndex
                                  ? ele[payOutHeaderValue[col]]
                                  : ele[payOutHeaderValue[col]]
                                      .split(" ")
                                      ?.slice(0, 10)
                                      ?.join(" ")}
                                <a
                                  id="payOutShowMoreBtn"
                                  onClick={() => {
                                    if (col === "Test Details") {
                                      // setShowData(!showData);
                                      setTableIndex(itemIndex);
                                      setShowData(
                                        showData && tableIndex === itemIndex
                                          ? false
                                          : true
                                      );
                                    }
                                  }}
                                >
                                  {ele[payOutHeaderValue[col]].split(" ")
                                    .length < 20
                                    ? ""
                                    : showData === true &&
                                      tableIndex === itemIndex
                                    ? " view less"
                                    : "...view more"}
                                </a>
                              </>
                            ) : col === "Appointment Closed Date" ? (
                              moment(ele?.appointmentClosedDate).format("ll")
                            ) : col === "Month" ? (
                              TotalProveiderMonth(ele?.year, ele?.month)
                            ) : col === "GST" ||
                              col === "Service Charges" ||
                              col === "Home Visit Amount" ||
                              col === "Adjustment Amount" ||
                              col === "Gross Amount" ? (
                              ele[payOutHeaderValue[col]]?.toLocaleString(
                                "en-IN"
                              )
                            ) : (
                              ele[payOutHeaderValue[col]]
                            )}
                          </td>
                        );
                      })}
                      <td>
                        <p
                          className={`status-style ${
                            ele?.insurerRequestStatus === "Paid"
                              ? "approved"
                              : ele?.insurerRequestStatus === "Removed"
                              ? "rejected"
                              : ele?.insurerRequestStatus ===
                                "Pending At Finance"
                              ? "pendingAtFinance"
                              : ele?.insurerRequestStatus ===
                                "Pending For Payment"
                              ? "pendingForpayment"
                              : ele?.insurerRequestStatus === "Partial Show"
                              ? "refundStatus"
                              : "pending"
                          }`}
                        >
                          {" "}
                          {ele?.insurerRequestStatus}
                        </p>
                      </td>
                      <td>
                        <button
                          className="btn search__btn action_export"
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#sendToQcModal"
                          disabled={
                            getNetworkMenuId()?.canEdit === false
                              ? true
                              : ele?.isInsurerPayoutStatus === false ||
                                ele?.insurerRequestStatus !==
                                  "Pending At Finance"
                              ? true
                              : ele?.billingRemoveFlag === "Y"
                              ? true
                              : false
                          }
                          onClick={() => setProviderDetail([ele])}
                        >
                          QC Approval
                        </button>
                      </td>
                      <td className="addHeader">
                        <button
                          className="dropdown open btn search__btn action_export"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          disabled={
                            ele?.billingRemoveFlag === "Y" ||
                            ele?.insurerRequestStatus !== "Pending At Finance"
                          }
                        >
                          Action &nbsp;
                          <i class="fa-solid fa-caret-right"></i>
                        </button>
                        <ul
                          className="dropdown-menu calling-dropdown-menu"
                          aria-labelledby="dropdownMenu2"
                        >
                          <li>
                            <button
                              className="dropdown-item appActionDropDwn"
                              type="button"
                              onClick={() => {
                                setProviderDetail([ele]);
                                setOpenModel({ ...openModel, editByFin: true });
                              }}
                            >
                              Edit By Finance
                            </button>
                          </li>
                          <li>
                            <button
                              className="dropdown-item appActionDropDwn"
                              type="button"
                              onClick={() => {
                                setOpenModel({
                                  ...openModel,
                                  adjustAmount: true,
                                });
                                setProviderDetail([ele]);
                              }}
                            >
                              Adjustment
                            </button>
                          </li>

                          <li>
                            <button
                              className="dropdown-item appActionDropDwn"
                              type="button"
                              data-bs-target="#removeBilling"
                              data-bs-toggle="modal"
                              onClick={() => {
                                setOpenModel({
                                  ...openModel,
                                  removeBilling: true,
                                });
                                setProviderDetail([ele]);
                              }}
                            >
                              Remove Billing
                            </button>
                          </li>

                          <li>
                            <button
                              className="dropdown-item appActionDropDwn"
                              type="button"
                              data-bs-target="#enableForInsurer"
                              data-bs-toggle="modal"
                              onClick={() => {
                                setProviderDetail([ele]);
                              }}
                            >
                              Enable for insurer
                            </button>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  );
                }
              )}
            </tbody>
          )}
        </table>
        {insBillReducer?.getInsAppointmentDetail?.length === 0 && (
          <p className="noRecordFound">No Record Found</p>
        )}
        <div className="d-flex justify-content-center mt-4">
          {globalReducer?.getTotalCount !== 0 && (
            <CustomPagination
              totalCount={globalReducer?.getTotalCount}
              perPageData={searchFilter?.rows}
              searchFilter={searchFilter}
              setSearchFilter={setSearchFilter}
              apiCall={GetTotalAppointmentAction}
              IsPayoutStatus={true}
            />
          )}
        </div>
        <div
          class="modal fade"
          id="enableForInsurer"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <EnableForInsurer
            providerDetail={providerDetail}
            setProviderDetail={setProviderDetail}
          />
        </div>
      </div>
    </>
  );
};
